import { PusherClient } from '@getaccept/pusher';
import _Vue from 'vue';

export default {
  install(Vue: typeof _Vue, baseUrl: string) {
    Vue.prototype.$pusher = new PusherClient(baseUrl);
  },
};
